import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faLinkedin,
  faBehance,
} from "@fortawesome/free-brands-svg-icons";

export default function Footerform() {
  return (
    <div>
      <div className="container-fluid footerform1" id="contact" style={{
        maxWidth:'1440px',
      }}>
     <div className="container-fluid footerform2" style={{
     maxWidth: '1280px',
      gap:'20px'
    }}>
<div className="row" style={{
}}>
<div className="col-lg-6 col-md-12 col-sm-12" style={{
  paddingTop: '20px',
  paddingBottom: '20px',
  display: 'flex',
  flexDirection: 'column',gap:'20px'
}}>
  <input type="text" placeholder='Your Name' style={{
    padding: '5px',
    borderRadius: '5px',
    border: '1px solid black', 
  }} />
  <input type="email" placeholder='Email' style={{
    padding: '5px',
    borderRadius: '5px',
    border: '1px solid black'
  }} />
  <input type="text" placeholder='Your Website (If exists)' style={{
    padding: '5px',
    borderRadius: '5px',
    border: '1px solid black'
  }} />
  <textarea placeholder='How can I help?*' style={{
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid black',
    resize: 'none', height: '100px'
  }} />
<div className="footerdiv">
  <button className='btn bg-black text-white footerbtn sora' style={{
    width: '173px',
    height: '56px',
    fontSize: '20px',
  }}>
    Get In Touch
  </button>
  <div className="footericon">
    <a href="https://www.instagram.com" className='aicon' target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faInstagram} size="1.5x" style={{
        border: '2px solid black',
        padding: '12px',
        color: 'black',
        borderRadius: '5px',
      }} />
    </a>
    <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faLinkedin} size="1.5x" style={{
        margin: "0 10px",
        border: '2px solid black',
        padding: '12px',
        color: 'black',
        borderRadius: '5px',
      }} />
    </a>
    <a href="https://www.behance.net" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faBehance} size="1.5x" style={{
        // margin: "0 10px",
        border: '2px solid black',
        padding: '12px',
        color: 'black',
        borderRadius: '5px',
      }} />
    </a>
  </div>
</div>


</div>
  <div className="col-lg-6 col-md-12 col-sm-12 mt-5" style={{paddingTop:'20px', paddingBottom:'20px',
  maxWidth:'600px'}}>
        <h1 className='footerformh1 sora' style={{ fontWeight:'800'}}>Let's <span className=''  style={{
                 WebkitTextStroke: '1px black',
                 color: 'white',                 
                 backgroundColor: 'transparent', fontWeight:'800'
            }}>talk</span> for something special</h1>
        <p className='sora footerp' style={{color:'#71717A'}}>I seek to push the limits of creativity to create high-engaging, user-friendly, and memorable interactive experiences.</p>
        <h1 className='footerform2 sora'>Soulja925@gmail.com</h1>
        <h1 className='footerform2 sora'>03448130027(WhatsApp)</h1>
        </div>
</div>
        </div>
      </div>
    </div>
  )
}
